import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {DialogService} from '@shared/services/dialog-service';

@Component({
    standalone: false,
    selector: 'particle-data-mapping-orbitax-field-cell-viewer',
  templateUrl: './data-mapping-orbitax-field-cell-viewer.component.html',
  styleUrls: ['./data-mapping-orbitax-field-cell-viewer.component.scss']
})
export class DataMappingOrbitaxFieldCellViewerComponent implements OnInit, AfterViewInit, CellComponent {
  fieldDefinition: FieldDefinition;
  item: any;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor(private dialogService: DialogService) {
  }

  ngOnInit() {


  }

  ngAfterViewInit(): void {

  }

  mapField(isNewField) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, isNewField: isNewField});
  }

  remove() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, isRemove: true});
  }

  showInfo() {
    const message = this.item.cells['MatchingKeyText'].displayText;
    this.dialogService.showDialogMessage('Match Field Key Purpose', message).subscribe(console.log);
  }
}
